export default {
  realtorList: [],
  isLoading: false,
  totalItems: 0,
  search: null
};
